import { cacheDom } from "../utils/QuerySelectors.js"

const dom = {}
const qs = {
  element: 'data-scrolled-page',
  content: 'data-terms-content',
  list: 'data-side-list',
  popup: 'data-popup',  
}
const qsAll = {
  links: 'data-link',
  buttons: 'data-mobile-table',
}

export const setupScrolledPage = () => {
  cacheDom(dom, qs, qsAll)
  if(dom.element) {
    const id = dom.element.dataset.sectionId
    const h2tags = dom.content.querySelectorAll('h2')
    h2tags.forEach((h2tag, index) => {
      if(h2tag.innerHTML.trim() != '') {
        h2tag.classList.add('h5')
        h2tag.id = `details-${id}-${index}`
        dom.list.innerHTML += `
          <li>
            <a class="!block p-3 text-2xl w-full text-left hover:bg-back-second rounded-lg !text-fore" href="#details-${id}-${index}" ${qsAll.links}>
              ${h2tag.innerHTML}
            </a>
          </li>
        `
      }
    })
    gsap.registerPlugin(ScrollTrigger, ScrollToPlugin)

    const links = gsap.utils.toArray(`[${qsAll.links}]`)
    links.forEach(a => {
      let element = document.querySelector(a.getAttribute("href")),
          linkST = ScrollTrigger.create({
                trigger: element,
                start: "top top"
              })
      ScrollTrigger.create({
        trigger: element,
        start: "top center",
        onToggle: self => self.isActive && setActive(a)
      })
      a.addEventListener("click", e => {
        e.preventDefault()
        gsap.to(window, {duration: 1, scrollTo: linkST.start, overwrite: "auto"})
      })
    })

    function setActive(link) {
      links.forEach(el => el.classList.remove("bg-back-second"))
      link.classList.add("bg-back-second")
    }

    dom.buttons.forEach(button => {
      button.innerHTML = window.globalIcons['icon-table'] + button.innerHTML
      button.addEventListener('click', () => {
        window.openPopup(`<ul class="mt-8 p-6">${dom.list.innerHTML}</ul>`)

        const popupLinks = dom.popup.querySelectorAll(`[${qsAll.links}]`)
        popupLinks.forEach(a => {
          let element = document.querySelector(a.getAttribute("href")),
          linkST = ScrollTrigger.create({
                trigger: element,
                start: "top top"
              })
          a.addEventListener("click", e => {
            e.preventDefault()
            window.closePopup()
            gsap.to(window, {duration: 1, scrollTo: linkST.start, overwrite: "auto"})
          })
        })
      })
    })
  }
}